import { render, staticRenderFns } from "./StoneShape.vue?vue&type=template&id=1af2dc61"
import script from "./StoneShape.vue?vue&type=script&lang=js"
export * from "./StoneShape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports